/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { DocumentDialogPreviewPanel } from "cms/documents/document-selector/dialog/panels/document-dialog-preview-panel";
import { DocumentListGallery } from "cms/documents/document-selector/gallery/document_list_gallery";
import { GalleryContext } from "cms/documents/document-selector/gallery/gallery-context";
import SearchFilter from "components/search-filter-list/search-filter-list";
import React, { Fragment, useContext } from "react";
import { useMountedState } from "react-use";

const DocumentDialogGalleryPanel = () => {

    const {
        documents = [],
        setDocuments,
        searchFunction
    } = useContext(GalleryContext);

    const [needsRefresh, setNeedsRefresh] = React.useState(false);
    const mounted = useMountedState();

    return (
        <Fragment>
            <div className="simplicity-document-selector-window-content-gallery">
                <SearchFilter
                    items={documents}
                    setItems={setDocuments}
                    autoLoad={true}
                    searchFunction={searchFunction}
                    needsRefresh={needsRefresh}
                    setNeedsRefresh={setNeedsRefresh}
                    instruction={"Select from existing documents"}
                    mounted={mounted}
                >
                    <DocumentListGallery />
                </SearchFilter>
            </div>

            <DocumentDialogPreviewPanel />

        </Fragment>
    );
};

export { DocumentDialogGalleryPanel };
